exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".purchase-order-header .purchase-order-heading{font-size:22px}.purchase-order-header .purchase-order-status{font-size:14px;font-style:italic;color:#696969}", ""]);

// exports
